import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ModuleContent from '../ModuleContent';
import styles from './ModuleContentList.style';

const ModuleContentList = ({ children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <ModuleContent className={className} {...other}>
      {children}
    </ModuleContent>
  );
};

ModuleContentList.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ModuleContentList.defaultProps = {
  className: '',
};

export default ModuleContentList;
